<template>
    <v-container>
        <v-row>
            <v-col cols="12" sm="6">
                <ValidatableTextField v-model:form="form" type="number" label="Carbon Amount *" :field="'carbon_amount_tco2e'" />
            </v-col>
            <v-col cols="6">
                <DatePicker v-model:field="form.date_of_transaction" v-model:form="form" label="Transaction Date *" :field-name="'date_of_transaction'" />
            </v-col>
            <v-col cols="12">
                <Autocomplete v-model:selected-items="form.steward_id" v-model:form="form" :field-name="'steward_id'" :items="stewards" label="Steward *" :loading="fetchingStewards" />
            </v-col>
            <v-col cols="12">
                <Autocomplete v-model:selected-items="form.company_id" v-model:form="form" :field-name="'company_id'" :items="clients" label="Client *" :loading="fetchingClients" />
            </v-col>
            <v-col cols="12">
                <Autocomplete v-model:selected-items="form.certifier_id" v-model:form="form" :field-name="'certifier_id'" :items="certifiers" label="Certificate Owner" :loading="fetchingCertifiers" />
            </v-col>
            <v-col cols="12">
                <Autocomplete v-model:selected-items="form.transaction_type_id" v-model:form="form" :field-name="'transaction_type_id'" :items="transactionTypes" label="Transaction Type *" :loading="fetchingTransactionTypes" />
            </v-col>
            <v-col cols="12">
                <v-row>
                    <v-col cols="6">
                        <ValidatableTextField v-model:form="form" type="number" label="Public Price" :field="'public_price'" />
                    </v-col>
                </v-row>
            </v-col>
            <v-col cols="12">
                <Autocomplete v-model:selected-items="form.partner_id" v-model:form="form" :field-name="'partner_id'" :items="partners" label="Partner" :loading="fetchingPartners" />
            </v-col>
        </v-row>
    </v-container>
</template>

<script setup lang="ts">
import { useInjectSubmitForm } from '@shared/composables/action-dialog/useInjectSubmitForm';
import { type ITransaction } from '@app/purchase/transaction/models/Transaction';
import { useTransactionRepository } from '@app/purchase/transaction/repositories/useTransactionRepository';
import { useStewardRepository } from '@app/land-hold/steward/repositories/useStewardRepository.ts';
import { useClientRepository } from '@app/purchase/client/repositories/useClientRepository.ts';
import { useCertifierRepository } from '@app/land-hold/certifier/repositories/useCertifierRepository.ts';
import { useTransactionTypeRepository } from '@app/purchase/transaction-type/repositories/useTransactionTypeRepository.ts';
import { usePartnerRepository } from '@app/purchase/partner/repositories/usePartnerRepository.ts';

const props = defineProps({
    item: {
        type: Object as PropType<ITransaction>,
        required: true,
    },
});

const store = useTransactionRepository().command.store(props.item);
const form = store.form;
useInjectSubmitForm(store.execute);

const { transactionTypes, fetchingTransactionTypes } = useTransactionTypeRepository().query.list();
const { stewards, fetchingStewards } = useStewardRepository().query.list();
const { clients, fetchingClients } = useClientRepository().query.list();
const { certifiers, fetchingCertifiers } = useCertifierRepository().query.list();
const { partners, fetchingPartners } = usePartnerRepository().query.list();
</script>
